import './style.scss';

interface IProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  circleColor?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  isPhoneNumber?: boolean;
}

const InfoCard = ({
  subtitle,
  title,
  circleColor,
  onClick,
  icon,
  isPhoneNumber = false
}: IProps) => {
  const titleComponent =
    isPhoneNumber && typeof title === 'string' ? (
      <a
        className="info-card__link"
        href={`tel:${title.replace(/\(|\)|-|\s/g, '')}`}
      >
        {title}
      </a>
    ) : (
      title
    );

  return (
    <div
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : '' }}
      className="info-card"
    >
      <h2 className="info-card__title">
        {titleComponent}
        {icon}
      </h2>
      <p className="info-card__subtitle">
        {circleColor && (
          <>
            <span
              style={{ backgroundColor: circleColor }}
              className="info-card__circle"
            ></span>{' '}
          </>
        )}
        {subtitle}
      </p>
    </div>
  );
};

export default InfoCard;
